import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

/**
 * GenerateLoader — animated inline loader for any "Generate with AI" button.
 *
 * Renders a rotating sparkle + three pulsing dots + shimmering label that
 * cycles through a set of phase-appropriate messages (so long generations
 * feel alive instead of frozen).
 *
 * Usage inside a button:
 *   {loading ? <GenerateLoader phrases={["Reading image…", "Thinking…"]} /> : <>Generate</>}
 */
export default function GenerateLoader({ phrases, label = "Generating" }) {
  const list = phrases && phrases.length ? phrases : [
    `${label}…`,
    `${label} · reading context…`,
    `${label} · thinking…`,
    `${label} · polishing…`,
  ];
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % list.length), 1600);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.length]);

  return (
    <span className="inline-flex items-center gap-2" data-testid="generate-loader">
      <Sparkles size={16} className="animate-[spin_2.4s_linear_infinite] text-[#FFB400]" />
      <span className="relative overflow-hidden">
        <span className="shimmer-text bg-clip-text text-transparent bg-gradient-to-r from-current via-white/70 to-current">
          {list[i]}
        </span>
      </span>
      <span className="inline-flex items-center gap-1 ml-1">
        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 animate-bounce" style={{ animationDelay: "300ms" }} />
      </span>
    </span>
  );
}
